import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { ICD10 } from '../../models/icd10';
import {
    getICD10s,
    searchICD10s
} from '../../apis/emr-data';

export interface State {
    byCode: Dictionary<ICD10>;
    loading: Dictionary<boolean>;
    searchedTextHash: Dictionary<boolean>;
}

export const icd10s = createModel<State>({
    state: {
        byCode: {},
        loading: {},
        searchedTextHash: {}
    },
    reducers: {
        update: (
            state: State,
            data: Undefinable<MixType<ICD10>>,
            loadingKey?: string
        ): State => ({
            ...state,
            byCode: {
                ...state.byCode,
                ...storeByCode(data)
            },
            ...loadingKey && {
                loading: {
                    ...state.loading,
                    [loadingKey]: false
                }
            }
        }),
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        }),
        setSearched: (state: State, text: string): State => ({
            ...state,
            searchedTextHash: {
                ...state.searchedTextHash,
                [text]: true
            }
        })
    },
    effects: () => ({
        async getICD10sAsync(
            codes: Undefinable<string>[],
            rootState: RootState
        ) {
            const notExistedIds = selectors.getOtherICD10Ids(rootState.icd10s, codes);
            if (notExistedIds.length > 0) {
                try {
                    const data = await getICD10s(notExistedIds);
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        },
        async searchICD10sAsync(text: string, rootState: RootState) {
            if (
                !selectors.getLoading(rootState.icd10s, `searchICD10sAsync---${text}`) &&
                !selectors.checkSearched(rootState.icd10s, text)
            ) {
                const textLower = text.toLowerCase();
                this.loading(`searchICD10sAsync---${textLower}`, true);
                try {
                    const data = await searchICD10s(textLower);
                    this.update(data, `searchICD10sAsync---${textLower}`);
                    this.setSearched(textLower);
                } catch (e) {
                    window.console.log(e);
                    this.loading(`searchICD10sAsync---${textLower}`, false);
                }
            }
        }
    })
});

const storeByCode = (data: Undefinable<MixType<ICD10>>): Dictionary<ICD10> => {
    if (data) {
        if (Array.isArray(data)) {
            return data.reduce(
                (prev, x) => {
                    prev[x.code] = x;
                    return prev;
                },
                {} as Dictionary<ICD10>
            );
        } else {
            return {
                [data.code]: data
            } as Dictionary<ICD10>;
        }
    } else {
        return {} as Dictionary<ICD10>;
    }
};
